import axios from "axios";
import customAxios, { LONG_TIMEOUT_MS } from "./axios";
import { generateEndpoint } from "./helper";

/**
 * `customRequest` antd Upload yang mengirim file lewat customAxios.
 * Upload via `action` + `headers` antd memakai XHR sendiri: header Authorization bisa basi
 * (token sudah di-refresh) dan 401 tidak ikut alur refresh + retry → "Unauthenticated."
 * sampai halaman di-reload. Lewat customAxios token selalu terbaru dan 401 di-refresh.
 * @param {string} path endpoint relatif, mis. "/WA/medias" (base URL diambil saat upload)
 * @param {object} headers header tambahan. Default X-App dihapus, seperti upload via `action`
 *   sebelumnya yang tidak mengirim X-App.
 */
export const createUploadRequest =
  (path, headers = { "X-App": null }) =>
  ({ file, filename, data, onProgress, onSuccess, onError }) => {
    const formData = new FormData();
    Object.entries(data || {}).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => formData.append(`${key}[]`, item));
      } else {
        formData.append(key, value);
      }
    });
    formData.append(filename, file, file.name);

    const controller = new AbortController();

    customAxios
      .post(generateEndpoint(path), formData, {
        headers: { "Content-Type": "multipart/form-data", ...headers },
        timeout: LONG_TIMEOUT_MS,
        signal: controller.signal,
        // Pesan error ditampilkan masing-masing komponen dari onChange
        skipErrorNotification: true,
        onUploadProgress: ({ loaded, total }) => {
          if (total) {
            onProgress({ percent: (loaded / total) * 100 });
          }
        },
      })
      .then((response) => onSuccess(response.data))
      .catch((error) => {
        // Dibatalkan antd (file dihapus / komponen unmount) → bukan error
        if (!axios.isCancel(error)) {
          onError(error, error?.response?.data);
        }
      });

    return { abort: () => controller.abort() };
  };
